module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.1a3ae7be.eot";